import React from "react";
import { SaveConfigContext } from "../context/SaveConfigContext";

/**
 * Get the save config manager from the context.
 * @returns the save config manager
 */
export const useSaveConfigManager = () => {
  const saveConfigManager = React.useContext(SaveConfigContext);

  // add validation for saveConfig

  return saveConfigManager;
};
